import { maybeGetGoalUpdateAriFromUrlUpdateId } from '@townsquare/goal-update-card/ari-utils';
import { createRelayResource } from '@townsquare/relay-utils';
import { ResourceContext } from '@townsquare/router/types';

import GoalUpdateComposerEmbedQuery, {
	type GoalUpdateComposerEmbedQuery as GoalUpdateComposerEmbedQueryType,
} from '../components/GoalUpdateComposerEmbed/__generated__/GoalUpdateComposerEmbedQuery.graphql';

export const goalUpdateComposerEmbedResource = createRelayResource<GoalUpdateComposerEmbedQueryType>({
	getQuery: (routerContext, resourceContext) => {
		const goalKey = routerContext.match.params.goalKey;

		const context = resourceContext as ResourceContext;
		const updateId = maybeGetGoalUpdateAriFromUrlUpdateId(routerContext.query.updateId, context.workspace?.cloudId);

		return {
			query: GoalUpdateComposerEmbedQuery,
			variables: {
				key: goalKey ?? '',
				updateId: updateId ?? '',
				isExistingUpdate: !!updateId,
			},
		};
	},
});
